import * as bisc from "./bisc";

import { checkPackageVersion } from "./package";
import { handleServiceException } from "./errors";

export function isServiceAvailable() {
    return new Promise((resolve, reject) => {
        bisc.isSecurityComponentsAvailable()
            .then(result => {
                if (result === true) {
                    resolve(true);
                } else {
                    reject('notInstalled');
                }
            }, () => {
                reject('notInstalled');
            })
            .catch(handleServiceException);
    });
}

export function isVersionAuthorized() {
    return new Promise((resolve, reject) => {
        bisc.getSecurityComponentsVersion()
            .then(version => {
                // check the version against config
                checkPackageVersion(version)
                    .then(response => {
                        if (response.authorized === true) {
                            const { deprecated, prototype } = response;
                            resolve({
                                version,
                                deprecated,
                                prototype
                            });
                        } else {
                            reject('refusedVersion');
                        }
                    });
            })
            .catch(handleServiceException);
    });
}

export function isCardReaderAvailable() {
    return new Promise((resolve, reject) => {
        bisc.isCardReaderAvailable()
            .then(response => {
                if (response === true) {
                    resolve(true);
                } else {
                    reject('noCardReader');
                }
            })
            .catch(handleServiceException);
    });
}

export function isIsabelCardReaderAvailable() {
    return new Promise((resolve, reject) => {
        bisc.isIsabelCardReaderAvailable()
            .then(response => {
                if (response === true) {
                    resolve(true);
                } else {
                    reject('noCardReader');
                }
            })
            .catch(handleServiceException);
    });
}

export function isCardCertificateValid() {
    return new Promise((resolve, reject) => {
        // the isCardCertificateValid method triggers the insert card prompt
        bisc.isCardCertificateValid()
            .then(response => {
                if (response === true) {
                    resolve(true);
                } else {
                    bisc.isIsabelCardAvailable()
                        .then(response => {
                            if (response === true) {
                                reject('noCertificate');
                            } else {
                                reject('invalidCard');
                            }
                        })
                        .catch(handleServiceException);
                }
            })
            .catch(handleServiceException);
    });
}

export function isIsabelCardAvailable() {
    return new Promise((resolve, reject) => {
        bisc.isIsabelCardAvailable()
            .then(response => {
                if (response === true) {
                    resolve(true);
                } else {
                    reject('invalidCard');
                }
            })
            .catch(handleServiceException);
    });
}
